import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscriber, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Product } from 'src/app/modals/product.model';
import { MatSnackBar } from '@angular/material';
import { map } from 'rxjs/operators';
import { ApiEndpoints } from './ApiEndpoints';
import { ApiUtils } from './ApiUtils';
import { Facture } from 'src/app/modals/facture';
import { Commande } from 'src/app/modals/commande';
import { plainToClass } from 'class-transformer';
import { SharedMethods } from './sharedMethods-service';
import { SidenavMenu } from '../sidebar/sidebar-menu.model';



// Get product from Localstorage
const products = JSON.parse(localStorage.getItem('compareItem')) || [];

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  public currency  = 'CFA';
  public catalogMode  = false;

  private _url = 'assets/data/';
  public url = 'assets/data/banners.json';

  public compareProducts : BehaviorSubject<Product[]> = new BehaviorSubject([]);
  public observer   :  Subscriber<{}>;

  public cacheProduct: Product[] = [];
  public cacheCategories: any[] = [];

  closePopupEvent = new Subject<any>();

  // tslint:disable-next-line:max-line-length
  constructor(private httpClient: HttpClient, public snackBar: MatSnackBar, public apiEndpoints: ApiEndpoints, public apiUtils: ApiUtils, public sharedMethods: SharedMethods) {
   // tslint:disable-next-line:no-shadowed-variable
   this.compareProducts.subscribe(products => products = products)

   /* this.products().subscribe( (prods: Product[]) => {
    this.cacheProduct = prods;
   }); */

  }

  private products(): Observable<Product[]> {
    // return this.httpClient.get<Product[]>('assets/data/products2.json');
    return this.httpClient.get<Product[]>(this.apiEndpoints.URL_GET_PRODUITS, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
    // return [];
  }

  public banners(): Observable<any[]>{
    return this.httpClient.get<any[]>(this.url);
  }


  // Get Banners
  public getBanners() {
    return this.banners();
  }

  // Get Banners
  public getProducts(): Observable<Product[]> {
    return this.products();
  }


  // Get Products By Id
  /* public getProduct(id: number): Observable<Product> {
    return this.products().pipe(map(items => {
      return items.find((item: Product) =>
        { return item.id === id; });
      }));
  } */


        /*
      ---------------------------------------------
      ----------  Compare Product  ----------------
      ---------------------------------------------
   */

// Get Compare Products
public getComapreProducts(): Observable<Product[]> {
  const itemsStream = new Observable(observer => {
    observer.next(products);
    observer.complete();
  });
  // tslint:disable-next-line:no-angle-bracket-type-assertion
  return <Observable<Product[]>>itemsStream;
}

// If item is aleready added In compare
public hasProduct(product: Product): boolean {
  // tslint:disable-next-line:no-shadowed-variable
  const item = products.find(item => item.id === product.id);
  return item !== undefined;
}

 // Add to compare
 public addToCompare(product: Product): Product | boolean {
  let message;
  let status;
  let item: Product | boolean = false;
  if (this.hasProduct(product)) {
    // tslint:disable-next-line:no-shadowed-variable
    item = products.filter(item => item.id === product.id)[0];
    const index = products.indexOf(item);
    this.snackBar.open('The product  ' + product.name + ' already added to comparison list.', '×', { panelClass: 'error', verticalPosition: 'top', duration: 3000 });

  } else {
    if(products.length < 4)
      products.push(product);
      message = 'The product ' + product.name + ' has been added to comparison list.';
      status = 'success';
      this.snackBar.open(message, '×', { panelClass: [status], verticalPosition: 'top', duration: 3000 });

  }
    localStorage.setItem('compareItem', JSON.stringify(products));
    return item;
}

// Removed Product
public removeFromCompare(product: Product) {
  if (product === undefined) { return; }
  const index = products.indexOf(product);
  products.splice(index, 1);
  localStorage.setItem('compareItem', JSON.stringify(products));
}

// Get Products By category
getProductById(prod: Product[],  includeprod: number[]): Product[] {

  return prod.filter((item: Product) => {
            if(includeprod.findIndex(elem => elem === item.id) > -1)
            return item;
         });

}


// Get Products By category
getProductByCategory(prod: Product[], slugcategory: string, excludeprod?: number, query?: string): Product[] {
  // alert(query);
  // console.log(query);
  return prod.filter((item: Product) => {
            if(slugcategory === 'all') {
              if(query === undefined || query === null)
              return item;
              else
              // tslint:disable-next-line:max-line-length
              return item.name.toLowerCase().includes(query) || (item.description !== null && item.description.replace( /(<([^>]+)>)/ig, '').includes(query)) || (item.category !== null && item.category.displayName.toLowerCase().includes(query));

              // tslint:disable-next-line:max-line-length
              // return item.name.toLowerCase().includes(query);


            }
            else {
              if( excludeprod !== undefined)
              // tslint:disable-next-line:max-line-length
              return item.category !== null && item.category.slug === slugcategory && item.id !== excludeprod;
              else
              return item.category !== null && item.category.slug === slugcategory;
            }
         });

}



// Get Products By category
getPromotion(prod: Product[]): Product[] {

  return prod.filter((item: Product) => {
            if(item.salePrice !== undefined && item.salePrice !== null)
            return item;
         });

}

// Get current product tags
public getCategories(prods: Product[]) {

  const uniqueCategories: SidenavMenu[] = [];
  const itemCategorie = Array();

  prods.map((product, index) => {
     if(product.category && product.category !== null) {
        const index = uniqueCategories.findIndex(elem=>elem.id === product.category.id);
        if(index === -1)  uniqueCategories.push(product.category);
     }
  });

  /* for (let i = 0; i < uniqueCategories.length; i++) {
    itemCategorie.push({brand:uniqueCategories[i]})
  } */
  // this.categories = itemCategorie;
  // console.log(this.categories);

  return uniqueCategories;
}


public category(): Observable<SidenavMenu[]> {
  // return this.httpClient.get<Product[]>('assets/data/products2.json');
  return this.httpClient.get<SidenavMenu[]>(this.apiEndpoints.URL_GET_CATEGORIES, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
  // return [];
}

  /* public getProductByCategory(category: string): Observable<Product[]> {

    // const result: Observable<Product[]> = new Observable<Product[]>();




      return this.products().pipe(map(items =>
          items.filter((item: Product) => {
            if(category === 'all')
              return item
              else
              return item.category === category;
          })
      ));


  } */


  saveFactureAndFlux(facture: Facture, cmd: Commande[], modepayment: string, devise: string) {

    const cmList = [];

    // flux livré
    if (cmd !== undefined) {

      // tslint:disable-next-line:prefer-for-of
      for ( let i = 0; i < cmd.length; i++) {

        const flux = {
          copyIdForUpdate: cmd[i].id,
          quantite: cmd[i].quantite,
          prixUnitaire: cmd[i].prix_unitaire,
          produit: cmd[i].produit.id,
          tva: cmd[i].tva,
          typeCalculTva: cmd[i].type_calcul_tva,
          description: cmd[i].description,
          // tva: facture.tva,
          remise: cmd[i].remise,
          affilate: cmd[i].affilate,
        };

        cmList.push(flux);

      }

    }



    // tslint:disable-next-line:variable-name
    let id_partner: number;
    if (facture.partenaire !== undefined && facture.partenaire !== null) {
      id_partner = facture.partenaire.id;
    } else {
      id_partner = null;
    }

    // tslint:disable-next-line:variable-name
    let id_resp: number;
    if (facture.resp !== undefined && facture.resp !== null) {
      id_resp = facture.resp.id;
    } else {
      id_resp = null;
    }


    const fac = {
      // dateFacturation: this.sharedMethods.converStringToDatetime(facture.date_facturation),
      // nbrJourEcheance: facture.nbr_jour_echeance,
      // dateRetour: this.sharedMethods.converStringToDatetime(facture.date_retour),
      typeFacture: 'vente',
      partenaire: id_partner,
      // resp: id_resp,
      note: facture.note,
      // ref: facture.ref,
      // livrer: false,
      payer: false, // facture.payer,
      // tslint:disable-next-line:object-literal-shorthand
      valider: false, // valider,
      commandesList: cmList,
      nomFacturation: facture.nom_facturation,
      telFacturation: facture.tel_facturation,
      paysFacturation: facture.pays_facturation,
      villeFacturation: facture.ville_facturation,
      adresseFacturation: facture.adresse_facturation,
      bpFacturation: facture.bp_facturation,
      zipcodeFacturation: facture.zipcode_facturation,
      prenomFacturation: facture.prenom_facturation,
      emailFacturation: facture.email_facturation,
    };

    /* console.log(fac);
    return */

    return this.httpClient.post(this.apiEndpoints.GET_URL_POST_FACTUREANDFLUX(modepayment, devise), fac, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()})

  }


  getFactures(from: string, to: string, type: string, idpartner: string, paidstatus: string, state: string) {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.get(this.apiEndpoints.URL_GET_FACTURES(from, to, type, idpartner, paidstatus, state), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});

  }


  getProductSeller(idVendeur: number) {
    return this.httpClient.get(this.apiEndpoints.URL_GET_PRODUITS_SELLER(idVendeur), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
  }

  getSouscriptions(iduser: number) {
    return this.httpClient.get(this.apiEndpoints.URL_GET_SOUSCRIPTIONS_USERS(iduser), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
  }

  getTransactions(iduser: number, numpage) {
    return this.httpClient.get(this.apiEndpoints.URL_GET_TRANSACTIONS(iduser, numpage), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
  }

  deleteProductSeller(idprod: number) {
    return this.httpClient.delete(this.apiEndpoints.GET_URL_DELETE_PRODUIT(idprod), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
  }

  categories(): Observable<any[]> {
    // return this.httpClient.get<Product[]>('assets/data/products2.json');
    return this.httpClient.get<any[]>(this.apiEndpoints.URL_GET_CATEGORIES, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});
    // return [];
  }

  getOneProduit(id: number) {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<any>(this.apiEndpoints.GET_URL_ONE_PRODUIT(id),{headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});


  }


  saveProduit(produit: Product) {

    let idcats: number[];


    if ( produit.categories !== undefined && produit.categories !== null && produit.categories.length > 0 ) {

      idcats = [];
      produit.categories.forEach( elem => {
        idcats.push(elem);
      })

    }

    const pat = {

      designation: produit.name,
      prixDetail: produit.price,
      description: produit.description,
      sellInLigne: produit.sell_in_ligne,
      categories: idcats,
      type: produit.type,
      souscribeMode: produit.souscribe_mode,
      // categories: id_cats,
      imagePrincipale: (produit.image_principale !== null && produit.image_principale !== undefined) ? produit.image_principale.id: null,
      // sellInLigne: produit.sell_in_ligne,
      // isPromo: produit.is_promo,
      // prixPromo: produit.prix_promo
      externalLink: produit.external_link,
      is_externalLink: produit.is_external_link,

    };


    if (produit.id !== 0) {

      // tslint:disable-next-line:max-line-length
      return this.httpClient.patch(this.apiEndpoints.GET_URL_PUT_PRODUIT_BY_SELLER(produit.id), pat, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});

      /* return new Promise<Produit>(resolve => {
        this.http.put(
          .subscribe((data: Produit) => {

              this.getProduits();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
          });
      }); */

    } else {

      return  this.httpClient.post(this.apiEndpoints.GET_URL_POST_PRODUIT, pat, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});

          /* .subscribe((data: Produit) => {

              this.getProduits();
              resolve(data);
              this.iSconnecting = false;

            },
            err => {
              this.sharedMethods.errorApiShow(err.error.code, err.error.message);
              // alert(JSON.stringify(err));
              this.iSconnecting = false;
            });
      }); */

    }



  }



  addImage(idprod: number, images: File[]) {

    const formData: FormData = new FormData();

    // tslint:disable-next-line:prefer-for-of
    for(let i=0; i < images.length; i++) {
      formData.append( 'filesdata[]', images[i]);
    }

    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(this.apiEndpoints.URL_PRODUIT_ADD_IMAGE(idprod), formData, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER_WITHOUT_CONTENT_TYPE()});

  }


  deleteImage(id: number, image: number) {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.delete(this.apiEndpoints.URL_PRODUIT_REMOVE_IMAGE(id, image),{headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});

  }

  addFichier(idprod: number, fichier: File) {


    const formData: FormData = new FormData();

    formData.append( 'filedata', fichier);

    /* const httpOptions = {
      headers: new HttpHeaders({
      'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
      'X-Tenant': this.apiUtils.TENANTDB,
      }).delete('Content-Type'),
    }; */

    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(this.apiEndpoints.URL_PRODUIT_ADD_FICHIER(idprod), formData, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER_WITHOUT_CONTENT_TYPE()});


  }

  deleteFichier(id: number, fichier: number) {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.delete(this.apiEndpoints.URL_PRODUIT_REMOVE_FICHIER(id, fichier),{headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});


  }

  addOtherFile(idprod: number, fichier: File) {


    const formData: FormData = new FormData();
    formData.append( 'filedata', fichier);

    /* const httpOptions = {
      headers: new HttpHeaders({
      'X-Auth-Token': this.apiUtils.CURRENT_ACCESS_TOKEN,
      'X-Tenant': this.apiUtils.TENANTDB,
      }).delete('Content-Type'),
    }; */

    // tslint:disable-next-line:max-line-length
    // return this.httpClient.post(this.apiEndpoints.URL_PRODUIT_ADD_OTHER_FICHIER(idprod), formData, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER_WITHOUT_CONTENT_TYPE()});
    return this.httpClient.post(this.apiEndpoints.URL_PRODUIT_ADD_OTHER_FICHIER(idprod), formData, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER_WITHOUT_CONTENT_TYPE(), reportProgress: true, observe: 'events'});
    
  }

  renameOtherFichier(fichier: number, newname: string) {

    const pat = {

      label: newname,

    }
    
    // tslint:disable-next-line:max-line-length
    return this.httpClient.patch(this.apiEndpoints.URL_PRODUIT_RENAME_OTHER_FICHIER(fichier), pat, {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});


  }

  deleteOtherFichier(id: number, fichier: number) {

    // tslint:disable-next-line:max-line-length
    return this.httpClient.delete(this.apiEndpoints.URL_PRODUIT_REMOVE_OTHER_FICHIER(id, fichier),{headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});


  }




  

  search(sell: string, publish: string, nbrresult: number, numpage: number, term?: string, idcat?: string, type?: string){

    let param = '';

    if(sell !== null) {

      if(param === '')
      param += '?sell=' + sell;
      else
      param += '&sell=' + sell;

    }

    if(publish !== null) {

      if(param === '')
      param += '?publish=' + publish;
      else
      param += '&publish=' + publish;

    }

    if(nbrresult !== null) {

      if(param === '')
      param += '?nbrresult=' + nbrresult.toString();
      else
      param += '&nbrresult=' + nbrresult.toString();

    }

    if(numpage !== null) {

      if(param === '')
      param += '?numpage=' + numpage.toString();
      else
      param += '&numpage=' + numpage.toString();

    }

    if(term !== null && term !== undefined) {

      if(param === '')
      param += '?search=' + term;
      else
      param += '&search=' + term;

    }

    if(idcat !== null && idcat !== undefined) {

      if(param === '')
      param += '?idCategory=' + idcat;
      else
      param += '&idCategory=' + idcat;

    }

    if(type !== null && type !== undefined) {

      if(param === '')
      param += '?type=' + type;
      else
      param += '&type=' + type;

    }

    return this.httpClient.get<any>(this.apiEndpoints.URL_GET_SEARCH + param, {headers: this.apiUtils.BASIC_API_REQUEST_HEADER()});

    // return this.httpClient.get<Deal[]>(Config.apiUrl+ 'admin/deals' + param, httpOptions);

  }



  getGains(iduser: number) {
    return this.httpClient.get(this.apiEndpoints.URL_GET_GAINS(iduser), {headers: this.apiUtils.SECURE_API_REQUEST_HEADER()});
  }



}
